export default __webpack_public_path__ + "static/realWorldImg3-02909373d4ac836a2c8087e06964632a.webp";